export default __webpack_public_path__ + "static/vaclav-f62d81ad6310fa35dad7a43df80cf3ec.jpg";